import {Box, Select} from '@mui/material'
import styled from 'styled-components'
import theme, {colors} from '../../../../styles/theme'

export const FilterBox = styled(Box)`
  display: flex;
  gap: 16px;
  margin-bottom: 24px;

  ${theme.breakpoints.down('md')} {
    flex-flow: column;
  }
`

export const RightFilter = styled(Box)`
  display: flex;
  gap: 16px;
  margin-left: auto;

  ${theme.breakpoints.down('md')} {
    margin-left: 0;
  }
`

export const StyledInput = styled.input`
  border-radius: 4px;
  border: 1px solid #ebeffc;
  background: #f6f6f6;
  font-size: 16px;
  font-style: italic;
  height: 40px;
  width: 400px;
  padding: 0 16px;
  box-sizing: border-box;
  color: ${colors.bksGray80};

  &:focus-visible {
    outline: none !important;
  }

  ${theme.breakpoints.down('md')} {
    width: 100%;
  }
`

export const StyledSelect = styled(Select)`
  font-size: 16px;
  text-transform: capitalize;
  width: 250px;
  height: 40px;

  && fieldset {
    border-color: #ebeffc;
  }

  &:hover {
    outline: none !important;
  }

  ${theme.breakpoints.down('md')} {
    width: 100%;
  }
`
